import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { isEmpty, debounce } from "lodash";

import "./sider.scss";
import Color from "@tool/color";
import {
  EntityXingzheng,
  Icon101InActive,
  Icon101Active,
  Icon102InActive,
  Icon102Active,
  Icon103InActive,
  Icon103Active,
  Icon104InActive,
  Icon104Active,
  Icon105InActive,
  Icon105Active,
  Icon106InActive,
  Icon106Active,
  Icon107InActive,
  Icon107Active,
  Icon108InActive,
  Icon108Active,
  Icon109InActive,
  Icon109Active,
  Icon110InActive,
  Icon110Active,
  Icon111InActive,
  Icon111Active,
  Icon112Active,
  Icon112InActive,
  Icon113Active,
  Icon113InActive,
  Icon114Active,
  Icon114InActive,
  Icon115Active,
  Icon115InActive,
} from "@styled/icon";
import moSider, { changePosition } from "./store";
import { toggleLoading } from "@store/index";
import moIndex, {
  updateRequest,
  researchRequest as requests1,
} from "../store/index";
// 行业研究
import moIndustryChain, {
  initIndustryChain,
} from "../industry-research/industry-chain/store";
import moTypicalPosition, {
  initTypicalPosition,
} from "../industry-research/typical-position/store";
import moCompanyDistribution from "../industry-research/company-distribution/store";
import moCompanyScale from "../industry-research/company-scale/store";
import moIndustryReport, {
  initIndustryReport,
} from "../industry-research/industry-report/store";
// 人力指标
import { initUpRate } from "../human-indicator/up-rate/store";
import { initTimeTrend } from "../human-indicator/time-trend/store";
import { initCityRate } from "../human-indicator/city-rate/store";
import { initCategory } from "../human-indicator/category-type-rate/store";
import { initDetailRate } from "../human-indicator/detail-category-rate/store";
import { initLeaveRate } from "../human-indicator/leave-rate/store";
import { initLeave } from "../human-indicator/leave-rate-time-trend/store";
import { initFreshSalary } from "../human-indicator/fresh-salary/store";
import { initDifferent } from "../human-indicator/city-different/store";

interface IProps {}
interface IState {}

const BaseButton = styled(Button)(() => ({
  width: "180px",
  height: "34px",
  justifyContent: "flex-start",
  marginTop: "6px",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: 1,
  borderRadius: "5px",
  color: Color.c55,

  "&.active": {
    color: Color.primary,
    backgroundColor: Color.primaryColor(0.05),
  },
}));

const HeadButton = styled(BaseButton)(() => ({}));

const TitleButton = styled(BaseButton)(() => ({
  paddingLeft: "20px",
}));

const Sider = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const location = useLocation();
  const urlParams = useParams();
  const { topPosition, originPosition } = moSider;
  const { industryArr } = moIndex;

  const onSider = (uriType: string, uri: string) => {
    console.log("当前地址 -- ", location.pathname);
    console.log("跳转的地址 -- ", uri);
    // uriType的值: index1 - 行业研究, index2 - 人力指标,
    // index3 - 人力需求, index4 - 福利洞察, index5 - 人才流动
    console.log("切换模块 -- ", uriType);

    if (uriType === "index1") {
      // 行业研究
    } else if (uriType === "index2") {
      // 人力指标
    } else if (uriType === "index3") {
      // 人力需求
    } else if (uriType === "index4") {
      // 福利洞察
    } else if (uriType === "index5") {
      // 人才流动
    }
    navi(uri);
  };

  const onScroll = () => {
    let newPosition = originPosition;
    const topDistance =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (topDistance === 0) newPosition = originPosition;
    else if (topDistance <= 315) newPosition = originPosition - topDistance;
    else if (topDistance > 315) newPosition = 70;
    changePosition(newPosition);
  };

  /****** 行业研究模块 start ******/

  // 行业研究模块 接口请求
  const researchRequest = (uri: string) => {
    toggleLoading(true);
    navi(uri);
    requests1();
  };

  // 点击 行业研究
  const onResearch0 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("industry-research")) {
      // 当id为0时，跳转到页面顶部
      window.scrollTo(0, 0);
      navi("industry-research/0");
    } else {
      // 模块外跳转，触发接口请求
      researchRequest("industry-research/0");
    }
  };

  // 点击 行业概览
  const onResearch1 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("industry-research")) {
      // 行业概览
      const distance1 = document.getElementById("research1")?.offsetTop || 325;
      window.scrollTo(0, distance1 + 40);
      navi("industry-research/1");
    } else {
      // 模块外跳转，触发接口请求
      researchRequest("industry-research/1");
    }
  };

  // 点击 行业研报
  const onResearch2 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("industry-research")) {
      // 行业概览
      const distance2 = document.getElementById("research2")?.offsetTop || 325;
      window.scrollTo(0, distance2 + 50);
      navi("industry-research/2");
    } else {
      // 模块外跳转，触发接口请求
      researchRequest("industry-research/2");
    }
  };

  /****** 行业研究模块 end ******/

  /****** 人力指标模块 start ******/

  // 人力指标 接口请求
  const indicatorRequest = (uri: string) => {
    // 人力指标
    toggleLoading(true);
    navi(uri);
    updateRequest();
  };

  // 涨薪率
  const indicator0 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("human-indicator")) {
      // 当id为0时，跳转到页面顶部
      window.scrollTo(0, 0);
      navi("human-indicator/0");
    } else {
      // 模块外跳转，触发接口请求
      indicatorRequest("human-indicator/0");
    }
  };
  // 涨薪率
  const indicator1 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("human-indicator")) {
      // 涨薪率
      const distance1 = document.getElementById("indicator1")?.offsetTop || 325;
      window.scrollTo(0, distance1 + 60);
      navi("human-indicator/1");
    } else {
      // 模块外跳转，触发接口请求
      indicatorRequest("human-indicator/1");
    }
  };
  // 离职率
  const indicator2 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("human-indicator")) {
      // 离职率
      const distance2 = document.getElementById("indicator2")?.offsetTop || 325;
      window.scrollTo(0, distance2 + 60);
      navi("human-indicator/2");
    } else {
      // 模块外跳转，触发接口请求
      indicatorRequest("human-indicator/2");
    }
  };
  // 应届生起薪
  const indicator3 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("human-indicator")) {
      // 应届生起薪
      const distance3 = document.getElementById("indicator3")?.offsetTop || 325;
      window.scrollTo(0, distance3 + 40);
      navi("human-indicator/3");
    } else {
      // 模块外跳转，触发接口请求
      indicatorRequest("human-indicator/3");
    }
  };
  // 城市薪酬差异系数
  const indicator4 = () => {
    // 模块内跳转，不触发接口请求
    if (location.pathname.includes("human-indicator")) {
      // 城市薪酬差异系数
      const distance4 = document.getElementById("indicator4")?.offsetTop || 325;
      window.scrollTo(0, distance4 + 60);
      navi("human-indicator/4");
    } else {
      // 模块外跳转，触发接口请求
      indicatorRequest("human-indicator/4");
    }
  };

  const getShow = useMemo(() => {
    let bool: any = false;
    if (!isEmpty(industryArr)) {
      industryArr.forEach((res: any) => {
        res.sub_industries.forEach((item: any) => {
          if (
            item.code === moIndex.industry.code &&
            res.info.name === "医药行业"
          ) {
            bool = true;
          }
        });
      });
    }
    return bool;
  }, [industryArr]);

  /****** 人力指标模块 end ******/

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {};
  }, []);

  return (
    <section className="sider_10 fixed_10" style={{ top: `${topPosition}px` }}>
      {/* <TitleButton className={(location.pathname === '/index' || location.pathname === '/index/') ? 'active' : ''}
        onClick={() => onSider('/index')}>
        <EntityXingzheng width={12} height={12} color={Color.c55} />&nbsp;概览
      </TitleButton> */}
      <HeadButton
        onClick={onResearch0}
        className={
          location.pathname.includes("industry-research") ? "active" : ""
        }
      >
        行业研究
      </HeadButton>
      <TitleButton
        onClick={onResearch1}
        className={[
          (location.pathname.includes("industry-research") &&
            urlParams?.id === "1") ? "active" : "",
        ].join(" ")}
      >
        {(location.pathname.includes("industry-research") &&
          urlParams?.id === "1") ||
        (location.pathname.includes("industry-research") &&
          urlParams?.id === "0") ? (
          <Icon101Active width={12} height={12} />
        ) : (
          <Icon101InActive width={12} height={12} />
        )}
        &nbsp;行业概览
      </TitleButton>
      <TitleButton
        onClick={onResearch2}
        className={
          location.pathname.includes("industry-research") &&
          urlParams?.id === "2"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("industry-research") &&
        urlParams?.id === "2" ? (
          <Icon102Active width={12} height={12} />
        ) : (
          <Icon102InActive width={12} height={12} />
        )}
        &nbsp;行业研报
      </TitleButton>
      <HeadButton
        onClick={indicator0}
        className={
          location.pathname.includes("human-indicator") ? "active" : ""
        }
      >
        人力指标
      </HeadButton>
      <TitleButton
        onClick={indicator1}
        className={[
          (location.pathname.includes("human-indicator") &&
            urlParams?.id === "1") ? "active" : "",
        ].join(" ")}
      >
        {(location.pathname.includes("human-indicator") &&
          urlParams?.id === "1") ||
        (location.pathname.includes("human-indicator") &&
          urlParams?.id === "0") ? (
          <Icon103Active width={12} height={12} />
        ) : (
          <Icon103InActive width={12} height={12} />
        )}
        &nbsp;涨薪率
      </TitleButton>
      <TitleButton
        onClick={indicator2}
        className={
          location.pathname.includes("human-indicator") && urlParams?.id === "2"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-indicator") &&
        urlParams?.id === "2" ? (
          <Icon104Active width={12} height={12} />
        ) : (
          <Icon104InActive width={12} height={12} />
        )}
        &nbsp;离职率
      </TitleButton>
      <TitleButton
        onClick={indicator3}
        className={
          location.pathname.includes("human-indicator") && urlParams?.id === "3"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-indicator") &&
        urlParams?.id === "3" ? (
          <Icon105Active width={12} height={12} />
        ) : (
          <Icon105InActive width={12} height={12} />
        )}
        &nbsp;应届生起薪
      </TitleButton>
      <TitleButton
        onClick={indicator4}
        className={
          location.pathname.includes("human-indicator") && urlParams?.id === "4"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-indicator") &&
        urlParams?.id === "4" ? (
          <Icon106Active width={12} height={12} />
        ) : (
          <Icon106InActive width={12} height={12} />
        )}
        &nbsp;城市薪酬差异系数
      </TitleButton>
      <HeadButton
        onClick={() => onSider("index3", "human-demand/0")}
        className={location.pathname.includes("human-demand") ? "active" : ""}
      >
        人才需求
      </HeadButton>
      <TitleButton
        onClick={() => onSider("index3", "human-demand/1")}
        className={[
          (location.pathname.includes("human-demand") &&
            urlParams?.id === "1") ? "active" : "",
        ].join(" ")}
      >
        {(location.pathname.includes("human-demand") &&
          urlParams?.id === "1") ||
        (location.pathname.includes("human-demand") &&
          urlParams?.id === "0") ? (
          <Icon107Active width={12} height={12} />
        ) : (
          <Icon107InActive width={12} height={12} />
        )}
        &nbsp;行业招聘趋势
      </TitleButton>
      <TitleButton
        onClick={() => onSider("index3", "human-demand/2")}
        className={
          location.pathname.includes("human-demand") && urlParams?.id === "2"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-demand") && urlParams?.id === "2" ? (
          <Icon108Active width={12} height={12} />
        ) : (
          <Icon108InActive width={12} height={12} />
        )}
        &nbsp;公司招聘动向
      </TitleButton>
      <TitleButton
        onClick={() => onSider("index3", "human-demand/3")}
        className={
          location.pathname.includes("human-demand") && urlParams?.id === "3"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-demand") && urlParams?.id === "3" ? (
          <Icon109Active width={12} height={12} />
        ) : (
          <Icon109InActive width={12} height={12} />
        )}
        &nbsp;城市招聘趋势
      </TitleButton>
      <TitleButton
        onClick={() => onSider("index3", "human-demand/4")}
        className={
          location.pathname.includes("human-demand") && urlParams?.id === "4"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-demand") && urlParams?.id === "4" ? (
          <Icon110Active width={12} height={12} />
        ) : (
          <Icon110InActive width={12} height={12} />
        )}
        &nbsp;职能招聘趋势
      </TitleButton>
      <TitleButton
        onClick={() => onSider("index3", "human-demand/5")}
        className={
          location.pathname.includes("human-demand") && urlParams?.id === "5"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("human-demand") && urlParams?.id === "5" ? (
          <Icon111Active width={12} height={12} />
        ) : (
          <Icon111InActive width={12} height={12} />
        )}
        &nbsp;热门细分职能
      </TitleButton>
      <HeadButton
        onClick={() => onSider("index4", "wealfare-insight/0")}
        className={
          location.pathname.includes("wealfare-insight") ? "active" : ""
        }
      >
        福利洞察
      </HeadButton>
      <TitleButton
        onClick={() => onSider("index4", "wealfare-insight/1")}
        className={[
          (location.pathname.includes("wealfare-insight") &&
            urlParams?.id === "1") ? "active" : "",
        ].join(" ")}
      >
        {(location.pathname.includes("wealfare-insight") &&
          urlParams?.id === "1") ? (
          <Icon112Active width={12} height={12} />
        ) : (
          <Icon112InActive width={12} height={12} />
        )}
        &nbsp;企业预算
      </TitleButton>
      <TitleButton
        onClick={() => onSider("index4", "wealfare-insight/2")}
        className={
          location.pathname.includes("wealfare-insight") &&
          urlParams?.id === "2"
            ? "active"
            : ""
        }
      >
        {location.pathname.includes("wealfare-insight") &&
        urlParams?.id === "2" ? (
          <Icon113Active width={12} height={12} />
        ) : (
          <Icon113InActive width={12} height={12} />
        )}
        &nbsp;员工喜好
      </TitleButton>
      {getShow && (
        <HeadButton
          onClick={() => onSider("index5", "talent-flow/0")}
          className={location.pathname.includes("talent-flow") ? "active" : ""}
        >
          人才流动
        </HeadButton>
      )}
      {getShow && (
        <TitleButton
          onClick={() => onSider("index5", "talent-flow/1")}
          className={[
            (location.pathname.includes("talent-flow") &&
              urlParams?.id === "1") ? "active" : "",
          ].join(" ")}
        >
          {(location.pathname.includes("talent-flow") &&
            urlParams?.id === "1") ? (
            <Icon114Active width={12} height={12} />
          ) : (
            <Icon114InActive width={12} height={12} />
          )}
          &nbsp;人才流动概览
        </TitleButton>
      )}
      {getShow && (
        <TitleButton
          onClick={() => onSider("index5", "talent-flow/2")}
          className={
            location.pathname.includes("talent-flow") && urlParams?.id === "2"
              ? "active"
              : ""
          }
        >
          {location.pathname.includes("talent-flow") &&
          urlParams?.id === "2" ? (
            <Icon115Active width={12} height={12} />
          ) : (
            <Icon115InActive width={12} height={12} />
          )}
          &nbsp;人才画像
        </TitleButton>
      )}
    </section>
  );
};

export default observer(Sider);
